import { updateList } from "@/mocks/anime";

export default function Updates() {
  return (
    <section id="updates" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-10 flex flex-col gap-4 md:mb-12 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-900">
              <i className="ri-refresh-line"></i>
              动画更新动态
            </span>
            <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">
              热门动画更新实时同步
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              第一时间掌握最新一集的更新进度，追番再也不怕错过。
            </p>
          </div>
          <a
            href="#schedule"
            className="inline-flex items-center gap-1 text-sm font-semibold text-primary-700 hover:text-primary-600"
          >
            返回时间表 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
          {updateList.map((item, idx) => (
            <article
              key={item.id}
              className="group flex items-center gap-4 rounded-2xl border border-background-200/80 bg-background-50 p-4 transition-all hover:border-secondary-300 hover:bg-background-100/60 md:p-5"
            >
              <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-secondary-100 text-secondary-700">
                <i className="ri-play-circle-line text-xl"></i>
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="truncate font-heading text-base text-foreground-950 md:text-lg">
                  {item.title}
                </h3>
                <p className="mt-0.5 truncate text-xs text-foreground-600">{item.episode}</p>
              </div>
              <div className="flex shrink-0 flex-col items-end gap-1.5">
                <span className="inline-flex items-center gap-1 rounded-full bg-accent-100 px-2.5 py-0.5 text-xs font-semibold text-accent-700">
                  <i className="ri-check-double-line"></i>
                  {item.status}
                </span>
                <span className="text-xs text-foreground-500">
                  {idx === 0 && <i className="ri-time-line mr-0.5"></i>}
                  {item.time}
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}